<template>
  <div class="only-label-and-value" v-show="elementActive">
    <div class="col-8 offset-2 field-response" v-show="label" v-html="label"></div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'OnlyLabel',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
